import React, { useEffect } from "react";

/** @jsx jsx */
/* @ts-ignore */
import { jsx, css } from '@emotion/react';

const style = css`
	position: absolute;
	margin: auto;
	top:0;
	bottom:0; /* vertical center */
	left:0;
	right:0; /* horizontal center */
`;

export const GameCanvas = ({ onReady }: { onReady: () => void }) => {
	useEffect(() => { onReady(); }, []);

	return (
		<canvas css={style} id="game-canvas" className="game-canvas" />
	);
};
